import Image from 'next/image';

import { imageLoaderForPath } from '../../../domains/Layout/Image/URL/ImageURL';
import { useFeatureFlag } from '../../hooks/useFeatureFlag';

export function PaymentLogo() {
    const { hasFeature } = useFeatureFlag();

    if (hasFeature('payment_ideal')) {
        return (
            <Image
                alt=""
                height={40}
                width={130}
                src="/partners/payment-ideal.png"
                loader={imageLoaderForPath}
            />
        );
    }

    if (hasFeature('payment_american')) {
        return (
            <Image
                alt=""
                height={40}
                width={130}
                src="/partners/payment-american.png"
                loader={imageLoaderForPath}
            />
        );
    }

    if (hasFeature('payment_postepay')) {
        return (
            <Image
                alt=""
                height={40}
                width={130}
                src="/partners/payment-postepay.png"
                loader={imageLoaderForPath}
            />
        );
    }

    return (
        <Image
            alt=""
            height={40}
            width={130}
            src="/partners/payment.png"
            loader={imageLoaderForPath}
        />
    );
}
